// extracted by mini-css-extract-plugin
export default {"wrapper":"ConsultationBox_wrapper__L+ckV","consultationBox":"ConsultationBox_consultationBox__Q-wK3","prompt":"ConsultationBox_prompt__JklB7"};